module.exports = __webpack_public_path__ + "static/media/vendora.ab919617.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vendora.webp
// module id = 260
// module chunks = 0